import styled from 'styled-components';
import { WidgetRowWrapper } from '../layout/WidgetRow.tsx';

export const ParentInfoWrapper = styled.div`
  width: auto;
  display: flex;
  position: relative;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  border-radius: 8px 8px 0 0;
  padding: 2px 8px;
  height: 24px;
  margin: -8px;
  margin-bottom: 0;

  background-color: ${props => props.theme.colorBorderSecondary};

  &:hover {
    // all'hover evidensiamo la barra del container
    background-color: ${props => props.theme.colorPrimaryBg};
  }

  // Se Questo container contiene altri container
  // Aumentiamo l'altezza del titolo per mostrare il nome del figlio
  // e cambiamo il colore di sfondo
  &.has-children-container.horizontal {
    height: 44px;
    background-color: ${props => props.theme.colorPrimaryBg};
    background-color: ${props => props.theme.colorBorderSecondary};
    &.is-over-me {
      background-color: ${props => props.theme.colorPrimary};
      color: #fff;
    }
  }

  &.is-over-me {
    background-color: ${props => props.theme.colorPrimary};
    color: #fff;
  }
  &.is-space-for-drag {
    background-color: transparent;
    &.is-over-me {
      background-color: transparent;
    }
  }
`;

export const SortableParentWidgetRenderWrapper = styled.div`
  width: auto;
  position: relative;
  border-radius: 8px;
  background-color: #fff;

  padding: 6px;
  padding-top: 0px;
  padding-bottom: 0px;

  margin: -8px;
  margin-top: -24px;
  margin-bottom: 0px;

  // Se il padre è un container
  // spostiamo il widget figlio per allineare gli input interni
  &.has-parent-container {
    margin-top: -24px;
    margin-bottom: 8px;
  }

  // Altezza minima per il drag and drop
  min-height: 72px;
  // Bordo intorno ai widget figli per evidenziare il container
  border: 2px solid ${props => props.theme.colorBorderSecondary};

  &:hover {
    // all'hover evidensiamo la barra del container
    border-color: ${props => props.theme.colorPrimaryBg};
    ${ParentInfoWrapper} {
      background-color: ${props => props.theme.colorPrimaryBg};
    }
  }

  &.is-over-me {
    border-color: ${props => props.theme.colorPrimary};
  }
  &.is-space-for-drag {
    border-color: transparent;
    background-color: transparent;
    &.is-over-me {
      border-color: transparent;
    }
    .sortable-parent-widget-render-wrapper {
      border-color: transparent;
      background-color: transparent;
    }
    ${ParentInfoWrapper} {
      background-color: transparent;
    }
  }
  &.is-drag-overlay {
    min-height: 68px;
    height: 68px;
    ${WidgetRowWrapper} {
      opacity: 0;
    }
  }
`;

export const TotalWrapper = styled.div`
  position: relative;
  padding-top: 24px;
  &.horizontal {
    padding-top: 0;
  }
  /* &.full-row-container,
  &:not(.has-parent-container) {
    padding-top: 24px;
  } */
`;
